var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 24h28v4H0zM0 12h28v4H0zM0 0h28v4H0z"
}))));
export { SvgIconMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0wIDI0aDI4djRoLTI4eiIvPjxwYXRoIGQ9Im0wIDEyaDI4djRoLTI4eiIvPjxwYXRoIGQ9Im0wIDBoMjh2NGgtMjh6Ii8+PC9nPjwvc3ZnPgo=";